import { formatToDollar, formatToPercent } from "@inrev/common";
import { SuretyAccountPreview } from "@portal/api/account/agent";
import { checkboxFilter } from "@portal/components/ui/FilterableDataTable";
import { getStatusTagByStatus, statusDisplayLabelMap } from "@portal/components/ui/StatusTag";
import type { ColumnDef } from "@tanstack/react-table";
import { DateTime } from "luxon";
import { formatDateForCsv, formatEmpty } from "../../../utils";

export const accountsTableColumns: ColumnDef<SuretyAccountPreview>[] = [
	{
		id: "status",
		accessorFn: (row) => statusDisplayLabelMap[row.status] ?? row.status,
		header: "Status",
		filterFn: checkboxFilter,
		cell: (props) => getStatusTagByStatus(props.row.original.status),
		minSize: 205,
		size: 205,
		meta: { headerFilterType: "checkbox" },
	},
	{
		id: "displayName",
		accessorFn: ({ displayName }) => formatEmpty(displayName),
		header: "Name",
		sortingFn: "textCaseSensitive",
	},
	{
		id: "rate",
		accessorFn: ({ contract }) => contract?.bondingLine?.rate ?? 0,
		cell: (props) => formatEmpty(formatToPercent(props.row.original.contract?.bondingLine?.rate)),
		enableGlobalFilter: false,
		header: "Rate",
	},
	{
		id: "singleLimit",
		accessorFn: ({ contract }) => contract?.bondingLine?.singleLimit ?? 0,
		cell: (props) =>
			formatEmpty(formatToDollar(props.row.original.contract?.bondingLine?.singleLimit, true)),
		enableGlobalFilter: false,
		header: "Single Limit",
	},
	{
		id: "aggregateLimit",
		accessorFn: ({ contract }) => contract?.bondingLine?.aggregateLimit ?? 0,
		cell: (props) =>
			formatEmpty(formatToDollar(props.row.original.contract?.bondingLine?.aggregateLimit, true)),
		enableGlobalFilter: false,
		header: "Aggregate Limit",
	},
	{
		id: "totalExposure",
		accessorFn: ({ contract }) => contract?.exposure.total ?? 0,
		cell: (props) => formatEmpty(formatToDollar(props.row.original.contract?.exposure.total, true)),
		enableGlobalFilter: false,
		header: "Total Exposure",
	},
	{
		id: "submittedAt",
		accessorFn: ({ submittedAt }) =>
			submittedAt !== undefined ? DateTime.fromISO(submittedAt).toJSDate() : undefined,
		cell: (props) =>
			props.row.original.submittedAt !== undefined
				? DateTime.fromISO(props.row.original.submittedAt).toLocaleString(DateTime.DATE_MED)
				: "--",
		enableGlobalFilter: false,
		header: "Submitted",
		sortingFn: "datetime",
		meta: { csvFormatter: formatDateForCsv },
	},
];
